import Section from '@/components/Section'
import React from 'react'
import Title from '@/components/Title'
import {
  GxIcon,
  GxTab,
  GxTabGroup,
  GxTabPanel
} from '@garpix/garpix-web-components-react'
import {
  androidColoredIcon,
  appleColoredIcon,
  linuxColoredIcon,
  windowsColoredIcon
} from '@/images'
import style from './styles/game_detail.module.scss'
// import Button from '@/components/Button'
import Container from '@/components/Container'
import { ISystemRequirements } from '@/interfaces/Game'
import classNames from 'classnames'

interface IProps {
  info: ISystemRequirements[]
}

const osIcons = {
  android: androidColoredIcon,
  ios: appleColoredIcon,
  linux: linuxColoredIcon,
  windows: windowsColoredIcon
}

const Requirements = ({ info = [] }: IProps): React.ReactElement => {
  return (
    <Section>
      <Container>
        <Title type='h2' theme='h3'>
          Системные требования
        </Title>
        <div className={style.req_tab__wrap}>
          <GxTabGroup>
            {info.map((item, index) => {
              return (
                <GxTab
                  active={index === 0}
                  key={item.id}
                  slot='nav'
                  panel={`req_${item.id}`}
                  className={style.req_tab__button}
                >
                  <GxIcon
                    src={osIcons[item.uf_os_key]}
                    className={style.req_tab__icon}
                  />
                  {item.uf_description}
                </GxTab>
              )
            })}
            {info.map((item, index) => {
              return (
                <GxTabPanel
                  active={index === 0}
                  name={`req_${item.id}`}
                  key={item.id}
                  className={style.req_tab__panel}
                >
                  <ul className={style.req_grid}>
                    {item.uf_os !== null && item.uf_os !== ''
                      ? (
                        <li className={style.req__item}>
                          <span className={style.req__item_title}>ОС:</span>
                          {item.uf_os}
                        </li>
                        )
                      : null}
                    {item.uf_video_card !== null &&
                    item.uf_video_card !== ''
                      ? (
                        <li className={style.req__item}>
                          <span className={style.req__item_title}>
                            Видеокарта:
                          </span>
                          {item.uf_video_card}
                        </li>
                        )
                      : null}
                    {item.uf_cpu !== null && item.uf_cpu !== ''
                      ? (
                        <li className={style.req__item}>
                          <span className={style.req__item_title}>
                            Процессор:
                          </span>
                          {item.uf_cpu}
                        </li>
                        )
                      : null}
                    {item.uf_disk_space !== null &&
                    item.uf_disk_space !== ''
                      ? (
                        <li className={style.req__item}>
                          <span className={style.req__item_title}>
                            Место на диске:
                          </span>
                          {item.uf_disk_space}
                        </li>
                        )
                      : null}
                    {item.uf_ram !== null && item.uf_ram !== ''
                      ? (
                        <li className={style.req__item}>
                          <span className={style.req__item_title}>
                            Оперативная память:
                          </span>
                          {item.uf_ram}
                        </li>
                        )
                      : null}
                  </ul>
                  {item.uf_file_build !== null
                    ? (
                      <a
                        href={item.uf_file_build}
                        download
                        className={classNames(
                          'highlight',
                          style.link,
                          style['link--corner'],
                          style.req__download
                        )}
                      >
                        Скачать
                      </a>
                      )
                    : null}
                  {
                    // Взято из условия выше item.uf_file_build !== null
                    // Гребаный линтер ненавидит комментарии в тернарнике
                    // <Button
                    //   href={item.uf_file_build}
                    //   download
                    //   size='large'
                    //   corner
                    //   highlight
                    //   wide
                    //   className={style.req__download}
                    // >
                    //   Скачать
                    // </Button>
                  }
                  {item.uf_build_link !== null && item.uf_build_link !== ''
                    ? (
                      <a
                        href={item.uf_build_link}
                        className={classNames(
                          'highlight',
                          style.link,
                          style['link--corner'],
                          style.req__download
                        )}
                      >
                        Скачать
                      </a>
                      )
                    : null}
                  {
                    // Взято из условия выше item.uf_build_link !== null && item.uf_build_link !== ''
                    // Гребаный линтер ненавидит комментарии в тернарнике
                    // <Button
                    //   target="_blank"
                    //   href={item.uf_build_link}
                    //   size="large"
                    //   corner
                    //   highlight
                    //   wide
                    //   className={style.req__download}
                    // >
                    //   Скачать
                    // </Button>
                  }
                </GxTabPanel>
              )
            })}
          </GxTabGroup>
        </div>
      </Container>
    </Section>
  )
}

export default Requirements
